import { Pagination } from "@/components/Pagination";
import { type OpenModalProps } from "@/features/calendar/openCalendarModal";
import { sortCalendarItems } from "@/features/calendar/utils/sortItems";
import { mapScheduleToActivity } from "@/features/calendar/work-schedule/getScheduleActivities";
import { Global, css } from "@emotion/react";
import { type Appointment, type Schedule, type Task } from "@repo/api";
import { Variables } from "@repo/skapa";
import { SectionContainer } from "@repo/ui";

import { type OutlookEvent } from "../types";
import { AgendaItem } from "./AgendaItem";

interface Props {
  items: (Appointment | Task)[];
  outlook: OutlookEvent[];
  schedules: Schedule[] | undefined;
  totalSize: number;
  size: number;
  setSize: (size: number) => void;
  openModal: (props: OpenModalProps) => void;
  mutateSearchAppointments?: () => void;
}

export const AgendaView = ({
  items,
  outlook,
  schedules,
  totalSize,
  size,
  setSize,
  openModal,
  mutateSearchAppointments,
}: Props) => {
  const scheduleActivities = schedules
    ? schedules.map(mapScheduleToActivity)
    : [];
  const allItems = [...items, ...outlook, ...scheduleActivities].sort(
    sortCalendarItems
  );

  return (
    <SectionContainer>
      <Global
        styles={css`
          .saleslead__agenda-list {
            display: flex;
            flex-direction: column;
            gap: ${Variables.space50};
            padding-inline: ${Variables.space50};
            margin: 0;
            list-style: none;
          }
        `}
      />
      <ul className="saleslead__agenda-list">
        {allItems?.map((a) => (
          <li key={a.id}>
            <AgendaItem
              item={a}
              openModal={openModal}
              mutateSearchAppointments={mutateSearchAppointments}
            />
          </li>
        ))}
      </ul>
      <Pagination
        setSize={setSize}
        size={size}
        totalNumber={totalSize + outlook.length + scheduleActivities.length}
        currentNumber={allItems?.length ?? 0}
      />
    </SectionContainer>
  );
};
